/**
 * components/DeviceLabelModal.js
 * The one-time "what is this computer called?" prompt (multi-device sync, step 4). Shown only
 * when the app runs on the shared online books and this browser hasn't answered yet. The name
 * is sent with every save, so "last saved by" and conflict messages can say WHO, while the app
 * has no login. Both buttons are a real answer, recorded by the caller (devicePrefs.js):
 *   Simpan  — saves the typed name (disabled while blank; use Lewati instead);
 *   Lewati  — skips, deliberately: saves show as "perangkat tanpa nama", never asked again.
 * Escape / clicking outside only closes it for now — not an answer — so it asks again next time.
 * The name can be changed later in Pengaturan.
 */
import React, { useState } from "react";
import { useModalEsc, backdropClose } from "../utils/modalStack";
import { DEVICE_LABEL_MAX } from "../utils/devicePrefs";

export default function DeviceLabelModal({ onSave, onSkip, onClose }) {
  const [label, setLabel] = useState("");
  useModalEsc(onClose);
  const trimmed = label.trim();

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box" onMouseDown={(e) => e.stopPropagation()}>
        <h2 className="modal-title">Nama Perangkat Ini</h2>
        <div className="page-sub" style={{ marginBottom: "var(--gap-lg)" }}>
          Data buku sekarang dipakai bersama di beberapa komputer. Beri nama komputer ini supaya
          setiap perubahan tercatat dari perangkat mana — misalnya &ldquo;Siti – laptop kasir&rdquo;.
        </div>
        <form onSubmit={(e) => { e.preventDefault(); if (trimmed) onSave(trimmed); }}>
          <div className="form-row">
            <label className="form-label" htmlFor="device-label-input">Nama perangkat</label>
            <input id="device-label-input" className="form-input" value={label} autoFocus
              maxLength={DEVICE_LABEL_MAX} onChange={(e) => setLabel(e.target.value)} />
            <div className="form-hint">Hanya disimpan di komputer ini. Bisa diubah nanti di Pengaturan.</div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn" onClick={onSkip}>Lewati</button>
            <button type="submit" className="btn btn-primary" disabled={!trimmed}>Simpan</button>
          </div>
        </form>
      </div>
    </div>
  );
}
